import "./chatlist.scss";
import { useChatList } from "./hooks/useChatList";
import Chatadduser from "../chatadduser/Chatadduser";
import { ChatSearchBar } from "./components/ChatSearchBar";
import { ChatItem } from "./components/ChatItem";
import { DeleteChatModal } from "./components/DeleteChatModal";

const Chatlist = () => {
  const state = useChatList();

  return (
    <div className="chatList">
        <ChatSearchBar 
          setInput={state.setInput} 
          addMode={state.addMode} 
          setAddMode={state.setAddMode} 
        />

        <div className="itemContainer">
          {state.filteredChats.map(chat => (
            <ChatItem 
              key={chat.chatId} 
              chat={chat} 
              selectChat={state.selectChat} 
              handleOpenDeleteModal={state.handleOpenDeleteModal} 
            />
          ))}
        </div>

        {state.addMode && (
          <Chatadduser onClose={() => state.setAddMode(false)} />
        )}

        {state.isDeleteModalOpen && (
          <DeleteChatModal 
            chatToDelete={state.chatToDelete}
            onCancel={state.handleCancelDelete}
            onConfirm={state.handleConfirmDelete}
          />
        )}
    </div>
  );
};

export default Chatlist;